import { render, staticRenderFns } from "./indexHermesBR.vue?vue&type=template&id=66ee12fb&scoped=true"
import script from "./indexHermesBR.vue?vue&type=script&lang=js"
export * from "./indexHermesBR.vue?vue&type=script&lang=js"
import style0 from "./indexHermesBR.vue?vue&type=style&index=0&id=66ee12fb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ee12fb",
  null
  
)

export default component.exports